<script setup>
import ConnectionState from '@/components/ConnectionState.vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'WaitingRoom',
});

const store = useStore();

const gotherapy = () => {
  store.commit('showLoading', true);
  store.commit('joinRoom', 'therapyroom');
};
</script>
<template>
  <div
    class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
  >
    <div class="content">
      <h1 class="maintitle title is-size-3-mobile is-size-2-tablet">
        WELKOM IN DE WACHTKAMER<br />VOOR KRENKTHERAPIE
      </h1>
    </div>

    <div class="content">
      <button
        class="button is-success is-large is-size-5-mobile is-size-4-tablet is-size-3-desktop"
        @click="gotherapy"
      >
        ga in therapie
      </button>
    </div>
    <div class="connectionstate"><ConnectionState></ConnectionState></div>
  </div>
</template>

<style lang="scss" scoped>
.connectionstate {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  margin: 1rem;
}
</style>
